import moment from "moment-timezone"

export const convertFromUtcToLocal = (dateToConvert): string => {
  return moment.tz(dateToConvert, "UTC").tz(moment.tz.guess(true)).format("MMM DD, YYYY h:mm A z")
}
